import { keyMatcher } from "@/utils/keyMatcher";

import type { KeyCombination } from "@corca/data";
import type { Editor } from "@tiptap/core";

export function remapShortcuts(
  map: Partial<Record<KeyCombination, ({ editor }: { editor: Editor }) => boolean>>,
) {
  const onKeyDown = (e: KeyboardEvent, editor: Editor) => {
    for (const [shortcut, action] of Object.entries(map)) {
      if (keyMatcher(shortcut as KeyCombination, e)) {
        if (action({ editor })) e.preventDefault();
      }
    }
  };

  let listener: (e: KeyboardEvent) => void;

  return {
    onCreate(this: { editor: Editor }) {
      listener = (e: KeyboardEvent) => onKeyDown(e, this.editor);
      document.addEventListener("keydown", listener);
    },
    onDestroy() {
      if (listener) document.removeEventListener("keydown", listener);
    },
    addKeyboardShortcuts() {
      return {};
    },
  } as const;
}
